<script>
import PageTitle from "@/components/standardComponents/PageTitle.vue";

export default {
  name: "MagicKitchenPresskit",
  components: {PageTitle}
}
</script>

<template>
  <PageTitle :page-title="'MAGIC KITCHEN'" :page-subtitle="['Magic', 'Kitchen', 'Presskit']"></PageTitle>
  <div class="press-kit-top press-kit">
    <div>
      <h1>Factsheet</h1>
      <h2>Developer:</h2>
      <p>Lars Hak/Studio Idem</p>
      <h2>Platform:</h2>
      <a class="link-social" target="_blank" href="https://store.steampowered.com/app/5049480/Magic_Kitchen/">Steam</a>
      <h2>Release status:</h2>
      <p>In Development <br>Release Fall 2027</p>
      <h2>Genres:</h2>
      <p>Casual, Cozy, Cooking, Restaurant, Co-op, Time management, Experimenting, Magic</p>
    </div>
    <div>
      <h1>Pitch</h1>
      <p>Serve your customers the perfect magic meals! You can take your time to freely experiment with ingredients, discover new meals, and master the perfect combinations. Play solo or co-op, whichever fits your vibe!</p>
      <h1>Description</h1>
      <h2 class="first-h2">Orders</h2>
      <p>Every customer has their own demands. Each meal is built from a mix of magical mushrooms and other ingredients that change how a dish looks, tastes, and scores.
        No two orders play out quite the same way. Have a customer with a different demand and you're making a completely different meal.</p>


      <h2>Experiment</h2>
      <p>Every ingredient has their own taste. Some pair well, while others clash. It's your task to find out which are the best combinations of ingredients, which can only be done by experimenting!</p>

      <h2>Get new tools</h2>
      <p>You're starting with a very simple restaurant, just making potions with mushrooms. But this will soon change to be a kitchen that's way more alive and has way more options. Get new utilities and buy new ingredients to keep improving your kitchen. </p>

      <h2>Make your kitchen reach 5/5 stars!</h2>
      <p>Success means taking care of your customers. Listening to their demands, timing your cooking right and finding the perfect combinations of ingredients. All these efforts will lead you to make your restaurant a 5 star restaurant, which is the ultimate goal!</p>

      <h2>Couch co-op mode</h2>
      <p>Team up with a friend in local co-op to make your kitchen even better! The easiest way to get many perfect meals is with two players!</p>
    </div>
  </div>
  <div class="press-kit">
    <h1>Media</h1>
    <h2 class="first-h2">Trailer</h2>
    <div class="video-wrapper">
      <iframe
          :src="`https://www.youtube.com/embed/lzfQz9mCGrI`"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen>
      </iframe>
    </div>
    <h2>Screenshots</h2>
    <div class="screenshots">
      <img class="screenshot" src="/ProjectImages/MagicKitchen/Screenshot%20Meal.jpg" alt="Magic Kitchen Screenshot"/>
      <img class="screenshot"  src="/ProjectImages/MagicKitchen/Screenshot%20Cutting.jpg" alt="Magic Kitchen Screenshot"/>
      <img class="screenshot"  src="/ProjectImages/MagicKitchen/Screenshot%20Order%20Complete.jpg" alt="Magic Kitchen Screenshot"/>
      <img class="screenshot"  src="/ProjectImages/MagicKitchen/Screenshot%20Potion.jpg" alt="Magic Kitchen Screenshot"/>
      <img class="screenshot"  src="/ProjectImages/MagicKitchen/Screenshot%20Order.jpg" alt="Magic Kitchen Screenshot"/>
      <img class="screenshot"  src="/ProjectImages/MagicKitchen/Screenshot%20Stars.jpg" alt="Magic Kitchen Screenshot"/>
    </div>
    <h2>Logo</h2>
    <div class="screenshots">
      <img class="screenshot" src="/ProjectImages/MagicKitchen/Logo.png" alt="Magic Kitchen Screenshot"/>
    </div>
  </div>
  <div class="press-kit">
    <h1>About the developer</h1>
    <p>
      Hi! I'm Lars, a solo developer, but mainly a software development teacher.
      I've been making games since 2019 as a hobby, but it's my dream to make it my job.
      <br><br>
      I have already released a game once in 2021 called The Steps as we know them.
      It was a puzzle game, which didn't do that well a release, but I'm still proud that I made it.
      <br><br>
      Magic Kitchen is a project in which I really see potential.
      If you want to playtest, make sure to reach out to me via X, BlueSky or YouTube.
    </p>
  </div>


</template>

<style scoped>
.press-kit-top{
  padding: 5rem 10% 0 10%;
  display: grid;
  grid-template-columns: 25% 70%;
  grid-gap: 5%;
}
.press-kit{
  text-align: left;
  background-color: #f7f2ea;
  background-image: url(http://www.transparenttextures.com/patterns/subtle-grunge.png);
  position: relative;
  width: 80%;
  padding: 0 10%;
}
h1{
  margin: 3rem 0 0 0;
}
.first-h2{
  margin-top: .5rem;
}
h2{
  margin-bottom: 0;
}
.link-social{
  display: inline-block;
  background-color: #db6457;
  color: white;
  padding: 0.4rem 1rem;
  border-radius: 1rem;
  font-size: .9rem;
  font-family: "Oswald Bold", sans-serif;
  margin-top: .3rem;
}
.video-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
  overflow: hidden;
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.screenshots{
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  align-content: start;
}
.screenshot{
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  min-width: 0;
  display: block;
}
</style>